import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
const resources = {
  en: {
    translation: {
      "home": "HOME",
      "aboutUs": "ABOUT US",
      "ourProjects": "OUR PROJECTS",
      "ourBusiness": "OUR BUSINESS",
      "companyNews": "COMPANY NEWS",
      "partners": "PARTNERS",
      "contactUs": "CONTACT US",
      // Add more translations as needed for your application

      //OUR Partner
      "ourpartner": "OUR PARTNERS",
      "part1": "King Saud University",
      "part2": "Qassim University",
      "part3": "Ministry of Health",



      // Footer translations
      "quickLinks": "Quick Links",
      "ourBusinessLinks": "Our Business",
      "media": "Media",
      "contactInformation": "Contact Information",
      "subscribeNewsletter": "Subscribe to our newsletter",
      "emailAddress": "Email Address",
      "privacyNote": "We respect your privacy. Emails will be used only for communication.",
      "termsConditions": "Terms & Conditions",
      "privacyPolicy": "Privacy Policy",
      "copyright": "© 2025 Al-Mansourya & Partners. All Rights Reserved.",
      "vatNumber": "VAT number: 300041931800003",
      "commercialRegistration": "C.R 1010062464 - Riyadh - Eng. Mansour Ali Al-Rejaie",
      "telephone": "Tel: 011 488 7491 / 011 488 7449",
      "fax": "Fax: 011 4823362",
      "correspondenceCode": "C.C (192031) P.O.Box: 7644 - Riyadh 11472",




      // Business section
      "ourBusinessTitle": "Our Business",
      "businessIntroduction": "Our company is a leader in construction, foundations, real estate development, and infrastructure.",
      "constructions": "Constructions",
      "infrastructure": "Infrastructure",
      "renovationMaintenance": "Renovation and Maintenance",

      //map
      "monday": {
        "day": "Monday",
        "hours": "7:00 am - 4:00 pm"
      },
      "tuesday": {
        "day": "Tuesday",
        "hours": "7:00 am - 4:00 pm"
      },
      "wednesday": {
        "day": "Wednesday",
        "hours": "7:00 am - 4:00 pm"
      },
      "thursday": {
        "day": "Thursday",
        "hours": "7:00 am - 2:30 pm"
      },
      "friday": {
        "day": "Friday",
        "hours": "Closed"
      },
      "saturday": {
        "day": "Saturday",
        "hours": "7:00 am - 4:00 pm"
      },
      "sunday": {
        "day": "Sunday",
        "hours": "7:00 am - 4:00 pm"
      },


      // Projects section
      "ourProjectsTitle": "Our Projects",
      "projectsDescription": "Explore the key projects we are working on.",
      "allProjectsButton": "All Projects",
      "allProjectsTitle": "All Projects",
      "pro1": "king Saud University",
      "pro2": "king Fahad Special Hospital Dammam",
      "pro3": "Maternity and Pediatric Hospital Madinah",
      "pro4": "The Governorate Offices Tabuk",
      "pro5": "The Governorate Offices AL-Qassim",
      "pro6": "AL-Qassim University",
      "pro7": "354 Health Center For Ministry of Health Nationwide",
      "pro8": "King Abdul-Aziz Hospital & Special Clinics Expansion, Riyadh",
      "pro9": "General Hospital Complex, Al Ras",
      "pro10": "Al-Qasim University Hospital",
      "pro11": "Central Service Building",

      "prod1": "University Infrastructure",
      "prod2": "Hospital Infrastructure & Departmental Layout",
      "prod3": "Hospital Construction and Comprehensive Medical Services Infrastructure",
      "prod4": "Government Administrative Facilities and Offices Infrastructure",
      "prod5": "Government Administrative Facilities and Offices Infrastructure",
      "prod6": "University Infrastructure",
      "prod7": "Health Center Infrastructure",
      "prod8": "Hospital Construction and Comprehensive Medical Services Infrastructure",
      "prod9": "Hospital Construction and Comprehensive Medical Services Infrastructure",
      "prod10": "Hospital Construction and Comprehensive Medical Services Infrastructure",
      "prod11": "University Construction",


      //News Section
      "NewsCompany": "Company News",
      "N1": "King Saud University Acting President and Doctor Mona Al-Malky Visits Al Mansouryah Construction Site",
      "N2": "Vice President for Projects and Delegation Inspect Al Mansouryah Construction Progress at King Saud University",
      "N3": "Inauguration Ceremony & Site Visit",
      "N4": "Engineer Abdullah Al Kahtani Visits King Saud University Project Site",
      "N5": "Site Visit for King Saud University Project",
      "N6": "King Abdul Aziz Hospital Expansion Project – Visit",

      "ND1": "The Acting President of King Saud University and Doctor Mona Al Malky Dean of the faculity of Finearts, accompanied by university officials, conducted an official site visit to review the progress of ongoing construction works being carried out by Al Mansouryah Construction Company.",
      "ND2": "Vice President for Projects at King Saud University, Prof. Abdullah Mohammed Al-Saqer, along with Prof. Saif Abdulaziz Alarifi, Engineer Hassan Al Gamal, and Engineer Yazeed Matary, conducted an on-site inspection of the ongoing construction works being executed by Al Mansouryah Construction Company. The visit aimed to review structural development, assess engineering progress, and ensure project quality and compliance with the university s standards. Al Mansouryah team provided detailed updates and reaffirmed their commitment to delivering the project with excellence and efficiency.",
      "ND3": "We are pleased to announce the successful inauguration of the new tent facility at our construction site. This structure will function as a temporary operations and coordination center, supporting ongoing project activities and providing a shaded space for team meetings and planning sessions.The inauguration was followed by an official site visit attended by our project managers, engineers, safety officers, and esteemed company representatives. During the visit, discussions focused on project progress, safety standards, and quality assurance measures.",
      "ND4": "We were honored to welcome Eng. Abdullah Al Kahtani during his recent visit to the King Saud University project site. The visit included a comprehensive tour of ongoing construction activities and project facilities, with a focus on progress updates, quality control, and site safety protocols.The visit highlights the ongoing collaboration between project stakeholders and the commitment to delivering high-standard infrastructure for one of the Kingdom’s leading academic institutions.We thank Eng. Al Kahtani and all team members for their continued support and dedication to project excellence.",
      "ND5": "As part of ongoing construction progress monitoring for a major King Saud University project, a site visit was conducted with the participation of key stakeholders. Attending the visit were Engineer Abdullah Sabhan, Engineer Abdullah Kahtan, Professor Abdullah Al-Saqer, and Engineer Hassan Al-Gamal, along with team members from AL MANSOURYAH Construction Company, the project’s executing contractor. The visit focused on project development, quality control, and aligning construction efforts with university expectations.",
      "ND6": "Our team had the honor of hosting key stakeholders during a site visit to the ongoing expansion works at King Abdul Aziz Hospital. The visit included a tour of the facilities and a detailed briefing on the projects progress and upcoming phases.",


      // About us section
      "aboutUsTitle": "Our Story",
      "companyIntro": "AL-Mansouryah",
      "chairmanTitle": "Chairman of the Board",
      "viceChairmanTitle": "Vice Chairman",
      "CN": "Eng. Sulaiman Al Rejaye",
      "VCN": "Eng. Mansour Al Rejaye",

      "Des": [
        "The company was established in 1974 and has more than 40 years of industry experience.",
        "Specializing in construction and equipping hospitals, governmental and educational buildings.",
        "Completed more than 750 large scale projects to date.",
        "Projects have included a 650 bed hospital, governorate offices, colleges, and universities.",
        "Our dedicated departments excel in designing, studying, equipping, and furnishing a wide range of facilities.",
        "The company has an exclusive agency for a number of reputable international companies specialized in medical, educational, and office equipment and furnishings."
      ],



      //Stat Section
      "stat1": "We proudly employ over 4,000 individuals, demonstrating our substantial presence and influence within the contracting industry.",
      "stat2": "Over the last 50 years, we've successfully completed major industrial and infrastructure projects across Saudi Arabia.",
      "stat3": "From bustling urban centers to remote landscapes, we have completed over 330 projects.",
      "stat4": "Received CLASS A classification in construction over 22 years ago. Awarded the following certifications (ISO: 9001:2008 - EMS 14001 - OHSAS 18001)",
      "Cardh1": "Employees",
      "Cardh2": "Years",
      "Cardh3": "Completed Projects",
      "Cardh4": "Years",

      //Our Value
      "titleValue": "Our Values",
      "Value1": "Excellence",
      "Value2": "Respect",
      "Value3": "Innovation",
      "Value4": "Impact",
 "Value5": "Commitment and Sustainable Development",
      "ValueD1": "At Al Mansouryah General Contracting, Excellence is the foundation of everything we build — delivering superior quality, precision, and reliability in every project.We strive for Excellence by consistently exceeding client expectations through innovation, integrity, and unmatched craftsmanship.",
      "ValueD2": "At Al Mansouryah, Respect guides our relationships — we value our clients, partners, and team by fostering trust, transparency, and mutual appreciation.We uphold Respect by listening, understanding diverse perspectives, and honoring our commitments with professionalism and integrity.",
      "ValueD3": "At Al Mansouryah, Innovation drives our progress — we embrace new technologies and creative solutions to build smarter, faster, and more efficiently.We believe Innovation is key to shaping the future of construction, ensuring each project meets modern standards and evolving client needs.",
      "ValueD4": "At Al Mansouryah, Impact means building more than structures — we create lasting value for communities, clients, and the environment.We measure our Impact by the positive change we bring through sustainable practices, quality work, and meaningful contributions to society.",
"ValueD5":"We are committed to national development goals, contributing to the achievement of Saudi Arabia's Vision 2030 and leaving a long-term positive impact on society and the economy.",

      //hero
      "title": "About us",
      "titleh": "BUILDING FOR FOUR DECADES...",
      "titleh2": "A LEGACY THAT FUELS FUTURE AMBITION.",

      //MissionVisionSection
      "mtitle": "Our Mission",
      "mdes": "Our Mission Strengthening our multinational relationships to increase our construction and equipment services while maintaining the highest global industry standards.",
      "vtitle": "Our Vision",
      "vdes": "To be vanguards in multinational development using the latest cutting-edge technologies.",

      "catalog": "Profile Catalog"



    }
  },
  ar: {
    translation: {
      "home": "الرئيسية",
      "aboutUs": "من نحن",
      "ourProjects": "مشاريعنا",
      "ourBusiness": "أعمالنا",
      "companyNews": "أخبار الشركة",
      "partners": "الشركاء",
      "contactUs": "اتصل بنا",
      // Add more translations for Arabic

      "ourpartner": "شركاؤنا",
      "part1": "جامعة الملك سعود",
      "part2": "جامعة القصيم",
      "part3": "وزارة الصحة",


      // Footer translations
      "quickLinks": "روابط سريعة",
      "ourBusinessLinks": "أعمالنا",
      "media": "وسائط",
      "contactInformation": "معلومات الاتصال",
      "subscribeNewsletter": "اشترك في نشرتنا الإخبارية",
      "emailAddress": "عنوان البريد الإلكتروني",
      "privacyNote": "نحن نحترم خصوصيتك. سيتم استخدام رسائل البريد الإلكتروني للتواصل فقط.",
      "termsConditions": "الشروط والأحكام",
      "privacyPolicy": "سياسة الخصوصية",
      "copyright": "© 2025 المنصورية وشركاؤها. جميع الحقوق محفوظة.",

      
      "commercialRegistration": "السجل التجاري: 1010062464 - الرياض - م. منصور علي الرجائي",
      "telephone": " 011 488 7449 / 011 488 7491",
      
      "correspondenceCode": "رمز المراسلة (192031) صندوق بريد: 7644 - الرياض 11472",

      //Our Value
      "titleValue": "قيمنا",
      "Value1": "الجودة والتميز",
      "Value2": "الاحترافية والكفاءة",
      "Value3": "الابتكار والتقنية",
      "Value4": "الشراكات الاستراتيجية",
      "Value5": "الالتزام والتنمية المستدامة",

      "ValueD1": "نلتزم بتنفيذ المشاريع وفق أعلى المعايير الفنية والهندسية، مع التركيز على الدقة والاحترافية في كل جانب من أعمالنا.",
      "ValueD2": "نعتمد على كفاءات وطنية مؤهلة وفرق عمل مدربة تدريبًا عاليًا لضمان تحقيق أفضل النتائج في كل مشروع.",
      "ValueD3": "نحرص على استخدام أحدث التقنيات والحلول الذكية في تنفيذ المشاريع، بما يسهم في تعزيز القيمة وإثراء تجربة العملاء.",
      "ValueD4": "نبني علاقات قوية ومستدامة مع الشركات العالمية الرائدة، لدعم مشاريعنا بأفضل الممارسات والخبرات الدولية.",
       "ValueD5":"نلتزم بأهداف التنمية الوطنية، بما يسهم في تحقيق رؤية المملكة 2030 وترك أثر إيجابي طويل الأمد على المجتمع والاقتصاد.",


      // Business section
      "ourBusinessTitle": "مجالنا",
      "businessIntroduction": "شركتنا رائدة في أعمال البناء والتأسيس، والتطوير العقاري، والبنية التحتية.",
      "constructions": "تأسيس وبناء",
      "infrastructure": "تطوير عقاري",
      "renovationMaintenance": "بنية تحتية",

      //map
      "monday": {
        "day": "الإثنين",
        "hours": "من 7:00 صباحًا إلى 4:00 مساءً"
      },
      "tuesday": {
        "day": "الثلاثاء",
        "hours": "من 7:00 صباحًا إلى 4:00 مساءً"
      },
      "wednesday": {
        "day": "الأربعاء",
        "hours": "من 7:00 صباحًا إلى 4:00 مساءً"
      },
      "thursday": {
        "day": "الخميس",
        "hours": "من 7:00 صباحًا إلى 2:30 مساءً"
      },
      "friday": {
        "day": "الجمعة",
        "hours": "مغلق"
      },
      "saturday": {
        "day": "السبت",
        "hours": "من 7:00 صباحًا إلى 4:00 مساءً"
      },
      "sunday": {
        "day": "الأحد",
        "hours": "من 7:00 صباحًا إلى 4:00 مساءً"
      },



      // Projects section
      "ourProjectsTitle": "مشاريعنا",
      "projectsDescription": "من أهم المشاريع",
      "allProjectsButton": "عرض جميع المشاريع",
      "allProjectsTitle": "جميع المشاريع",
      "pro1": "جامعة الملك سعود",
      "pro2": "مستشفى الملك فهد التخصصي بالدمام",
      "pro3": "مستشفى النساء والولادة بالمدينة المنورة",
      "pro4": " مبنى إمارة تبوك",
      "pro5": "مبنى إمارةالقصيم",
      "pro6": "جامعةالقصيم",
      "pro7": " 354 مركزاً صحياً تابعاً لوزارةالصحة في أرجاءالمملكة ",
      "pro8": "توسعة مستشفى الملك عبد العزيز الجامعي بالرياض",
      "pro9": "مجمع المستشفى العام، الراس",
      "pro10": "مستشفى جامعة القصيم",
       "pro11": "   مبنى الخدمات المركزية ",


      "prod1": "البنية التحتية للجامعة",
      "prod2": "البنية التحتية للمستشفى وتخطيط الأقسام",
      "prod3": "بناء المستشفيات والبنية التحتية للخدمات الطبية الشاملة",
      "prod4": "البنية التحتية للمرافق الإدارية والمكاتب الحكومية",
      "prod5": "البنية التحتية للمرافق الإدارية والمكاتب الحكومية",
      "prod6": "البنية التحتية للجامعة",
      "prod7": "البنية التحتية للمركز الصحي",
      "prod8": "بناء المستشفيات والبنية التحتية للخدمات الطبية الشاملة",
      "prod9": "بناء المستشفيات والبنية التحتية للخدمات الطبية الشاملة",
      "prod10": "بناء المستشفى والبنية التحتية الشاملة للخدمات الطبية",
   "prod11": "البنية التحتية للجامعة",



      //News Section 
      "NewsCompany": "أخبار الشركة",
      "N1": "زيارة معالي رئيس جامعة الملك سعود المكلف والدكتورة منى المالكي لموقع بناء المنصورية",
      "N2": "نائب الرئيس للمشاريع والوفود يتفقد سير العمل في مشروع المنصورية بجامعة الملك سعود",
      "N3": "حفل الافتتاح وزيارة الموقع",
      "N4": "المهندس عبدالله القحطاني يزور موقع مشروع جامعة الملك سعود",
      "N5": "زيارة موقع مشروع جامعة الملك سعود",
      "N6": "مشروع توسعة مستشفى الملك عبد العزيز – زيارة",

      "ND1": "قام معالي مدير جامعة الملك سعود المكلف وعميدة كلية الفنون الجميلة الدكتورة منى المالكي، برفقة مسؤولي الجامعة، بزيارة رسمية للموقع للاطلاع على تقدم أعمال البناء الجارية التي تقوم بها شركة المنصورية للإنشاءات",
      "ND2": "أجرى نائب رئيس جامعة الملك سعود للمشاريع، الأستاذ الدكتور عبد الله محمد الصقر، برفقة الأستاذ الدكتور سيف عبد العزيز العريفي، والمهندس حسن الجمل، جولة تفقدية ميدانية على أعمال البناء الجارية التي تنفذها شركة المنصورية للإنشاءات. هدفت الزيارة إلى مراجعة التطورات الإنشائية، وتقييم التقدم الهندسي، والتأكد من جودة المشروع وامتثاله لمعايير الجامعة. وقد قدم فريق المنصورية تحديثات مفصلة، ​​وأكد التزامهم بتنفيذ المشروع بتميز وكفاءة",
      "ND3": "يسرنا أن نعلن عن الافتتاح الناجح لمرفق الخيام الجديد في موقع البناء الخاص بنا. سيعمل هذا المرفق كمركز مؤقت للعمليات والتنسيق، يدعم أنشطة المشروع الجارية، ويوفر مساحة مظللة لاجتماعات الفريق وجلسات التخطيط. أعقب الافتتاح زيارة رسمية للموقع حضرها مديرو المشاريع والمهندسون ومسؤولو السلامة وممثلو الشركة الكرام. تركزت المناقشات خلال الزيارة على تقدم المشروع، ومعايير السلامة، وإجراءات ضمان الجودة.",
      "ND4": "تشرفنا باستقبال المهندس عبد الله القحطاني خلال زيارته الأخيرة لموقع مشروع جامعة الملك سعود. شملت الزيارة جولة شاملة على أنشطة البناء الجارية ومرافق المشروع، مع التركيز على مستجدات التقدم، ومراقبة الجودة، وبروتوكولات السلامة في الموقع. وتُبرز الزيارة التعاون المستمر بين الجهات المعنية بالمشروع، والالتزام بتوفير بنية تحتية عالية الجودة لإحدى المؤسسات الأكاديمية الرائدة في المملكة. نتقدم بالشكر للمهندس القحطاني وجميع أعضاء الفريق على دعمهم المتواصل وتفانيهم في سبيل تحقيق التميز في المشروع.",
      "ND5": "في إطار متابعة سير العمل في مشروع رئيسي بجامعة الملك سعود، نُظمت زيارة ميدانية بمشاركة الجهات المعنية الرئيسية. وحضر الزيارة المهندس عبد الله سبهان، والمهندس عبد الله قحطان، والأستاذ الدكتور عبد الله الصقر، والمهندس حسن الجمل، إلى جانب أعضاء فريق شركة المنصورية للإنشاءات، المقاول المنفذ للمشروع. وركزت الزيارة على تطوير المشروع، ومراقبة الجودة، ومواءمة جهود البناء مع توقعات الجامعة.",
      "ND6": "تشرف فريقنا باستضافة أصحاب المصلحة الرئيسيين خلال زيارة ميدانية لأعمال التوسعة الجارية في مستشفى الملك عبد العزيز. وتضمنت الزيارة جولة في المرافق واطلاعًا مفصلاً على تقدم المشروع والمراحل القادمة.",

      //Mission & Vission
      "mtitle": "رسالتنا",
      "mdes": "في شركة المنصورية، نلتزم بتقديم خدمات مقاولات متكاملة ترتقي إلى أعلى معايير الجودة، وتتماشى مع تطلعات عملائنا، وتسهم في مسيرة التنمية في المملكة، من خلال فرق عمل مؤهلة، وتقنيات متقدمة، وشراكات استراتيجية على المستويين المحلي والدولي.",
      "vtitle": "رؤيتنا",
      "vdes": "أن نكون من روّاد قطاع المقاولات على المستويين الوطني والإقليمي، من خلال تقديم حلول إنشائية متكاملة تسهم في تحقيق أهداف رؤية السعودية 2030، وتلبي تطلعات عملائنا، مستندين في ذلك إلى خبرة تمتد لأكثر من 50 عامًا، وكفاءات وطنية مؤهلة، وشراكات استراتيجية مع شركات عالمية رائدة.",



      // About us section
      "aboutUsTitle": "من نحن",
      "companyIntro": "المنصورية",
      "chairmanTitle": "رئيس مجلس الإدارة",
      "viceChairmanTitle": "نائب رئيس مجلس الإدارة",
      "CN": "م. سليمان بن علي الرجيعي",
      "VCN": "م. منصور بن علي الرجيعي",
      "Des": [
        "تأسست شركة المنصورية للمقاولات العامة عام 1396هـ (1975م)، لتبدأ مسيرةً حافلة تمتد لأكثر من خمسة عقود من التميز والريادة في قطاع الإنشاءات داخل المملكة العربية السعودية.",
        "تميزت الشركة بخبرتها الواسعة في تصميم وبناء وتجهيز المستشفيات والمرافق التعليمية مثل الجامعات والكليات، وذلك وفق أعلى المعايير الفنية والهندسية المعتمدة.",
        "ونتيجة لهذا التميز، حصلت المنصورية على تصنيف الدرجة الأولى في مجال الإنشاءات والمباني لأكثر من 22 عامًا متتالية، ما يعكس ثقة القطاعين العام والخاص في قدراتها.",
        "بفريق عمل يتجاوز 4000 موظف من المهندسين والإداريين المهرة والعمالة المدربة تدريبًا عاليًا، تقدم المنصورية حلولًا متكاملة تسهم في تحقيق رؤية المملكة وتلبية متطلبات المشاريع الوطنية الكبرى.",
        "كما تضم الشركة أقسامًا متخصصة في التصميم والدراسات والمعدات الطبية، وتفخر بكونها الوكيل الحصري لعدد من الشركات العالمية الرائدة في تصنيع المعدات الطبية والتعليمية.",
       
      ],

      //hero
      "title": "معلومات عنا",
      "titleh": "خمسة عقود من البناء...",
      "titleh2": "وماضٍ يؤسس طموح المستقبل",

      //stat section
      "stat1": "نفخر بتوظيف أكثر من 4000 موظف ضمن كوادرنا، وهو ما يجسد حضورنا القوي وتأثيرنا البارز في قطاع المقاولات، ويعكس التزامنا بتعزيز الكفاءة والاحترافية في جميع أعمالنا.",
      "stat2": "على مدى أكثر من خمسة عقود، نجحت شركة المنصورية في تنفيذ مشاريع صناعية كبرى وأعمال بنية تحتية متقدمة في مختلف مناطق المملكة العربية السعودية، مما رسّخ مكانتها كأحد أبرز الشركات الرائدة في قطاع الإنشاءات.",
      "stat3": "لقد أنجزت شركة المنصورية أكثر من 330 مشروعًا متنوعًا، شملت عدة قطاعات مختلفة، مما يعكس خبرتها الواسعة وقدرتها على تنفيذ المشاريع بكفاءة وجودة عالية.",
      "stat4": "تمتلك الشركة تصنيف الفئة (أ) في مجال الإنشاءات لأكثر من 22 عامًا متتالية، وحازت خلال هذه الفترة على عدة شهادات آيزو دولية أبرزها ISO 9001:2008 لنظام إدارة الجودة، وISO 14001 لنظام الإدارة البيئية، وOHSAS 18001 للصحة والسلامة المهنية. ",
      "Cardh1": "موظفين",
      "Cardh2": "عام",
      "Cardh3": "المشاريع المنجزة",
      "Cardh4": "من التميز",
      "catalog": "كتالوج الشركة"




    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;